var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"details-link",attrs:{"href":_vm.href,"target":_vm.target}},[_vm._v(" "+_vm._s(_vm.$t('more'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }